/** @global discount **/
document.addEventListener('alpine:init', () => {
    Alpine.data('app_list_orders', () => ({
        init: function () {
            const _this = this;

            this.$watch('print_visibility', function(){
                _this.renderPrintIframeContent();
            })
        },
        print_size: 'mm-80',
        order: null,
        print_visibility: [
            'printDate', 'shopName', 'orderInfo', 'orderItems', 'orderTotals', 'customerInfo', 'productImages', 'taxInfo'
        ],

        showOrderDetailModal: async function (unique_id, url) {
            const order = await this.get(url.replace('unique_id', unique_id));

            if (order.error){
                toastr.error(order.error);
            } else {
                this.order = order;
                $('#order_detail_modal').modal();
            }
        },
        showOrderPrintModal: async function (unique_id, url) {
            const order = await this.get(url.replace('unique_id', unique_id));

            if (order.error){
                toastr.error(order.error);
            } else {
                this.order = order;
                $('#order_detail_modal').modal('hide');

                this.order.print_date = moment().format('DD/MM/YYYY HH:mm:ss');

                $('#order_print_modal').modal();
                setTimeout(() => this.renderPrintIframeContent())
            }
        },

        renderPrintIframeContent: function () {
            const html80mm = document.getElementById('html-mm-80').innerHTML;
            const htmla4 = document.getElementById('html-a-4').innerHTML;

            const mm80doc = document.getElementById('mm-80').contentWindow.document;
            mm80doc.open();
            mm80doc.write(html80mm);
            mm80doc.close();

            const a4doc = document.getElementById('a-4').contentWindow.document;
            a4doc.open();
            a4doc.write(htmla4);
            a4doc.close();
        },
        printOrder: async function (url, order_status_wait_approve, order_status_approved) {
            const el_printDate = window.frames[this.print_size].document.querySelector('.print-date');

            if(el_printDate){

                el_printDate.innerText = moment().format('DD/MM/YYYY HH:mm:ss');

            }

            window.frames[this.print_size].focus();
            window.frames[this.print_size].print();

            this.order.print_count += 1;

            const response = await this.put(url.replace('unique_id', this.order.unique_id), {
                field: 'print_count',
                value: this.order.print_count
            });


            document.querySelector('.show-print-count[data-unique_id="'+this.order.unique_id+'"]').dataset.print_count = response.value;

            const el_order_status = document.querySelector('.order-status[data-unique_id="' + this.order.unique_id + '"]');

            if (el_order_status && parseInt(el_order_status.value) === order_status_wait_approve) {

                el_order_status.value = order_status_approved;
                el_order_status.dispatchEvent(new Event('change', {
                    bubbles: true,
                    cancelable: true,
                }));

            }
        },

        get: async function (url) {
            try {
                const response = await fetch(
                    url,
                    {
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        }
                    }
                );

                return await response.json();
            } catch (error) {
                return { error: error.message };
            }
        },
        put: async function (url, data) {
            try {
                const response = await fetch(
                    url,
                    {
                        method: 'PUT',
                        headers: {
                            'Accept': 'application/json',
                            'Content-Type': 'application/json',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        },
                        body: JSON.stringify(data)
                    }
                );

                return await response.json();
            } catch (error) {
                return { error: error.message };
            }
        }
    }));
});
